import React, { useState, useEffect } from 'react';
import { Battery } from 'lucide-react';

export function BatteryIndicator({ lang = 'zh' }: { lang?: 'en' | 'zh' }) {
  const [level, setLevel] = useState<number | null>(null);
  const [charging, setCharging] = useState(false);

  useEffect(() => {
    const nav = navigator as any;
    if (nav.getBattery) {
      nav.getBattery().then((b: any) => {
        setLevel(Math.round(b.level * 100));
        setCharging(b.charging);
        b.addEventListener('levelchange', () => setLevel(Math.round(b.level * 100)));
        b.addEventListener('chargingchange', () => setCharging(b.charging));
      }).catch(() => setLevel(null));
    }
  }, []);

  if (level === null) return <Battery size={14} />;

  return (
    <div
      className="flex items-center gap-1"
      title={lang === 'zh' ? `电池 ${level}%${charging ? ' (充电中)' : ''}` : `Battery ${level}%${charging ? ' (charging)' : ''}`}
    >
      <Battery size={14} className={level <= 20 ? 'text-red-400' : level <= 50 ? 'text-yellow-400' : ''} />
      <span className="text-xs font-bold">{level}%</span>
    </div>
  );
}
